import {CloseIconWrapper, SearchInputsWrapper, SearchInput} from "../MobileSearchBar/styles";
import SearchIcon16 from "../../icons/SearchIcon16";
import {CloseIcon} from "../../icons";
import {FC} from "react";
import {useTheme} from "styled-components";
import { useRouteMatch } from "react-router-dom";

interface SearchInputProps {
    searchText: string;
    setSearchText: (val: string) => void;
    placeholder: string;
}

export const SearchInputComponent: FC<SearchInputProps> = ({placeholder, setSearchText, searchText}) => {
    const isProjectEditPage = !!useRouteMatch('/edit');
    const theme = useTheme();

    return <SearchInputsWrapper width={'100%'} height={'100%'} isProjectEditPage={isProjectEditPage}>
        <SearchIcon16 fill={theme.tags.modal.search.color}/>
        <SearchInput
            style={{zIndex: 1}}
            onChange={(e) => setSearchText(e.target.value)}
            placeholder={placeholder}
            value={searchText}
        />
        {searchText?.length !== 0 && <CloseIconWrapper onClick={() => {setSearchText('');}}>
            <CloseIcon fill={theme.tags.modal.search.color} />
        </CloseIconWrapper>}
    </SearchInputsWrapper>
}import {CloseIconWrapper, SearchInputsWrapper, SearchInput} from "../MobileSearchBar/styles";
import SearchIcon16 from "../../icons/SearchIcon16";
import {CloseIcon} from "../../icons";
import {FC} from "react";
import {useTheme} from "styled-components";
import { useRouteMatch } from "react-router-dom";

interface SearchInputProps {
    searchText: string;
    setSearchText: (val: string) => void;
    placeholder: string;
}

export const SearchInputComponent: FC<SearchInputProps> = ({placeholder, setSearchText, searchText}) => {
    const isProjectEditPage = !!useRouteMatch('/edit');
    const theme = useTheme();

    return <SearchInputsWrapper width={'100%'} height={'100%'} isProjectEditPage={isProjectEditPage}>
        <SearchIcon16 fill={theme.tags.modal.search.color}/>
        <SearchInput
            style={{zIndex: 1}}
            onChange={(e) => setSearchText(e.target.value)}
            placeholder={placeholder}
            value={searchText}
        />
        {searchText?.length !== 0 && <CloseIconWrapper onClick={() => {setSearchText('');}}>
            <CloseIcon fill={theme.tags.modal.search.color} />
        </CloseIconWrapper>}
    </SearchInputsWrapper>
}